import React, { useRef } from "react";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import RouteDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import PaginatedRouteDropdown from "../../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper";
import { getBrands } from "../../ProductCatalogue/repositories/BrandCampaignRepository";
import { Btn } from "../../../AbstractElements";
import { FaTrash } from "react-icons/fa";
import ReusableCheckBox from "../../Configuration/ReusableComponents/ReusableCheckBox";
import { handleMedia } from "../../edetailing/repository/EdetailingRepository";
import { useGetSGPIStatus } from "../hooks/useSGPI";
import { useGetOrgUnitsData } from "../../Configuration/Grade Master/hooks/useGradeMaster";
import { useOnboardingOutletTypesData } from "../../Onboarding/hooks/useOnBoard";

type Props = {
  setFormValues?: any;
  formValues?: any;
  handleSubmit?: any;
  handleClose?: any;
  setSelectedBrands?: any;
  selectedBrands?: any;
  modalStatus?: any;
};

const SGPIMasterModalContent = ({
  setFormValues,
  formValues,
  handleSubmit,
  handleClose,
  setSelectedBrands,
  selectedBrands,
  modalStatus,
}: Props) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const BASE_URL = "https://tspc-development.truesales.in/media?id=";

  const { data: statusSGPIData } = useGetSGPIStatus({
    enable: true,
  });

  const { data: orgUnitsData, isLoading: orgUnitLoading } = useGetOrgUnitsData({
    enable: true,
  });

  console.log(
    "🚀 ~ SGPIMasterModalContent.tsx:44 ~ SGPIMasterModalContent ~ orgUnitsData:",
    orgUnitsData
  );

  const { data: onboardOutletTypesData } = useOnboardingOutletTypesData({
    enable: true,
  });

  const formattedSGPITypesData = Object.entries(
    statusSGPIData?.data?.SgpiType || {}
  ).map((item: any) => ({
    id: item[0],
    label: item[1],
  }));

  const formattedSGPIStatusData = Object.entries(
    statusSGPIData?.data?.Status || {}
  ).map((item: any) => ({
    id: item[0],
    label: item[1],
  }));

  const formattedOrgUnitData = Object.entries(orgUnitsData?.data || {}).map(
    (item: any) => ({
      id: item[0],
      label: item[1],
    })
  );

  console.log(
    "🚀 ~ SGPIMasterModalContent.tsx:74 ~ SGPIMasterModalContent ~ formattedOrgUnitData:",
    formattedOrgUnitData
  );

  const outletTypesOptions = onboardOutletTypesData?.data
    ? Object.entries(onboardOutletTypesData?.data || {}).map((item: any) => ({
        id: item[0],
        label: item[1],
      }))
    : [];

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      try {
        const mediaId = await handleMedia(file);
        setFormValues((prev: any) => ({ ...prev, media: mediaId }));
      } catch (error) {
        console.error("Media upload failed:", error);
      }
    }
  };

  const handleDropdownSelect = (field: string, value: string | number) => {
    setFormValues((prevState: any) => ({
      ...prevState,
      [field]: value,
    }));
  };

  // Handle checkbox change
  const handleCheckboxChange = (checked: boolean) => {
    setFormValues((prev: any) => ({
      ...prev,
      isstrategic: checked,
    }));
  };

  const handleInputChange = (
    name: any,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;
    const numericFields = ["mobile", "registration"];
    const updatedValue = numericFields.includes(name)
      ? value.replace(/[^0-9]/g, "")
      : value;

    setFormValues((prevState: any) => ({
      ...prevState,
      [name]: numericFields.includes(name)
        ? updatedValue === ""
          ? ""
          : Number(updatedValue)
        : updatedValue,
    }));
  };

  const handleOrgUnitChange = (selected: any) => {
    console.log(
      "🚀 ~ SGPIMasterModalContent.tsx:139 ~ handleOrgUnitChange ~ selected:",
      selected
    );

    setFormValues((prev: any) => ({
      ...prev,
      orgunit: selected,
    }));
    setSelectedBrands(null); // reset brand when orgunit changes
  };

  return (
    <div>
      {/* Form Details */}
      <div style={{ borderBottom: "1px solid #dedede", width: "100%" }}></div>
      <div className="row mb-0">
        <div className="col-sm-4">
          <CustomInput
            label="SGPI Name"
            placeholder="Enter SGPI Name"
            type="text"
            name="name"
            asterisk={true}
            value={formValues?.name}
            disabled={modalStatus === "View"}
            onChange={(e) => handleInputChange("name", e)}
          />
        </div>
        <div className="col-sm-4">
          <CustomInput
            label="SGPI Code"
            placeholder="Enter SGPI Code"
            type="text"
            name="code"
            asterisk={true}
            value={formValues?.code}
            disabled={modalStatus === "View"}
            onChange={(e) => handleInputChange("code", e)}
          />
        </div>
        <div className="col-sm-4">
          <RouteDropdown
            options={formattedOrgUnitData || []}
            value={formValues?.orgunit}
            asterisk={true}
            onChange={(val) => handleOrgUnitChange(val)}
            DropdownHeading="Org Unit"
            isDisabled={modalStatus === "View"}
            placeholder="Select Org Unit"
          />
        </div>{" "}
        <div className="col-sm-4">
          <PaginatedRouteDropdown
            key={formValues?.orgunit || "no-orgunit"} // <- this is the fix
            DropdownHeading="Brands"
            initialSelectedOptions={selectedBrands}
            placeholder="Select Brands"
            asterisk={true}
            isDisabled={!formValues?.orgunit || modalStatus === "View"}
            onChange={(val: any) => {
              setSelectedBrands(val);
            }}
            fetchOptions={async (page: any, search: any) => {
              if (!formValues?.orgunit) {
                return [];
              }

              try {
                const res = await getBrands({
                  page,
                  limit: 10,
                  Orgunitid: formValues?.orgunit,
                  search: search || "",
                });

                return (
                  res?.data?.data?.map((item: any) => ({
                    id: item?.BrandId,
                    label: item?.BrandName,
                  })) || []
                );
              } catch (error) {
                console.error("Error fetching brands:", error);
                return [];
              }
            }}
          />
        </div>
        <div className="col-sm-4">
          <CustomInput
            label="SKU"
            placeholder="Enter SKU"
            type="text"
            name="sku"
            disabled={modalStatus === "View"}
            asterisk={true}
            value={formValues?.sku}
            onChange={(e) => handleInputChange("sku", e)}
          />
        </div>{" "}
        <div className="col-sm-4">
          <CustomInput
            label="Quantity"
            placeholder="Enter Quantity"
            asterisk={true}
            type="number"
            disabled={modalStatus === "View"}
            name="qty"
            value={formValues?.qty}
            onChange={(e) => handleInputChange("qty", e)}
          />
        </div>{" "}
        <div className="col-sm-4">
          <RouteDropdown
            options={formattedSGPITypesData || []}
            value={formValues?.sgpitypes}
            asterisk={true}
            onChange={(value: any) => {
              handleDropdownSelect("sgpitypes", value);
            }}
            DropdownHeading="SGPI Type"
            isDisabled={modalStatus === "View"}
            placeholder="Select SGPI Type"
          />
        </div>
        <div className="col-sm-4">
          <RouteDropdown
            options={formattedSGPIStatusData || []}
            value={formValues?.status}
            asterisk={true}
            onChange={(value: any) => {
              handleDropdownSelect("status", value);
            }}
            DropdownHeading="Status"
            isDisabled={modalStatus === "View"}
            placeholder="Select Status"
          />
        </div>{" "}
        <div className="col-sm-4">
          <RouteDropdown
            options={outletTypesOptions || []}
            value={formValues?.outlettype}
            asterisk={true}
            onChange={(value: any) => {
              handleDropdownSelect("outlettype", value);
            }}
            DropdownHeading="Outlet Type"
            isDisabled={modalStatus === "View"}
            placeholder="Select Outlet Type"
          />
        </div>
        <div className="col-sm-4 mt-3">
          <CustomInput
            label="Start Date"
            placeholder="Enter Start Date"
            type="date"
            name="startdate"
            disabled={modalStatus === "View"}
            asterisk={true}
            value={formValues?.startdate}
            onChange={(e) => handleInputChange("startdate", e)}
          />
        </div>{" "}
        <div className="col-sm-4 mt-3">
          <CustomInput
            label="End Date"
            placeholder="Enter End Date"
            type="date"
            asterisk={true}
            disabled={modalStatus === "View"}
            name="enddate"
            value={formValues?.enddate}
            onChange={(e) => handleInputChange("enddate", e)}
          />
        </div>
        {(modalStatus === "Edit" || modalStatus === "Add") && (
          <div className="col-md-4 mt-5">
            <input
              type="file"
              accept="image/*"
              multiple // ✅ this is required
              ref={fileInputRef}
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
            <Btn
              style={{
                display: "flex",
                backgroundColor: "#43B9B2",
                color: "white",
                justifyContent: "center",
                alignItems: "end",
              }}
              type="submit"
              onClick={handleButtonClick}
            >
              {"Upload Media"}
            </Btn>
          </div>
        )}
        <div className="col-sm-6 mt-2">
          {formValues.media && (
            <div className="col-sm-12">
              <div
                style={{
                  position: "relative",
                  display: "inline-block",
                }}
              >
                <img
                  src={
                    formValues?.media
                      ? `${BASE_URL}${formValues?.media}`
                      : "https://via.placeholder.com/100?text=No+Image"
                  }
                  alt="Uploaded Media"
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "8px",
                    marginTop: "8px",
                    objectFit: "cover",
                  }}
                />
                {/* Trash Icon */}
                {(modalStatus === "Edit" || modalStatus === "Add") && (
                  <FaTrash
                    size={14}
                    onClick={() =>
                      setFormValues((prev: any) => ({
                        ...prev,
                        media: "",
                      }))
                    }
                    style={{
                      position: "absolute",
                      top: "4px",
                      left: "auto",
                      right: "-1px",
                      cursor: "pointer",
                      color: "red",
                      backgroundColor: "rgba(0,0,0,0.6)",
                      borderRadius: "50%",
                      fontSize: "14px",
                      padding: "4px",
                      width: "20px",
                      height: "20px",
                    }}
                  />
                )}
              </div>
            </div>
          )}
        </div>
        <div className="col-sm-7" style={{ marginLeft: "-12px" }}>
          <ReusableCheckBox
            data={[
              {
                label: "Is Strategic?",
                value: "active",
                checked: formValues.isstrategic, // <-- bind to formValues
              },
            ]}
            onCheckedChange={(checkedItems) =>
              handleCheckboxChange(checkedItems.includes("active"))
            }
            disabled={modalStatus === "View"}
          />
        </div>
      </div>
      <br />

      {/* Buttons */}

      <div className="d-flex justify-content-start gap-2">
        {(modalStatus === "Edit" || modalStatus === "Add") && (
          <Btn
            style={{ backgroundColor: "#43B9B2", color: "white" }}
            type="submit"
            onClick={handleSubmit}
          >
            {modalStatus === "Edit" ? "Update" : "Submit"}
          </Btn>
        )}
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </div>
  );
};

export default SGPIMasterModalContent;
